import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import Rightbar from 'pages/main/cheques/Rightbar'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import PeriodPicker from 'pages/parts/PeriodPicker'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import { httpOk, GET, FILE_D } from 'helpers/api'
import { formatMoney, returnSign, formatDate, findKeyFromArrayByValue } from 'helpers/helpers'
import { businessToday, businessMonthStart } from 'helpers/businessDay'

function Index() {
	const { t } = useTranslation()
	const reduxAccount = useSelector(state => state.account)

	const groupBy = [
		{ 'id': 'menu', 'name': t('menu') },
		{ 'id': 'product', 'name': t('product') },
	]

	const [data, setData] = useState({
		'data': [],
		'total_sales': 0,
		'total_sales_with_percentage': 0,
	})
	const [menu, setMenu] = useState([])
	const [poses, setPoses] = useState([])
	const [products, setProducts] = useState([])
	const [users, setUsers] = useState([])
	const [paymentTypes, setPaymentTypes] = useState([])
	const [orderTypes, setOrderTypes] = useState([])
	const [orderSubTypes, setOrderSubTypes] = useState([])
	const [preparationPlaces, setPreparationPlaces] = useState([])
	const [showRightBar, setShowRightBar] = useState(false)
	const [selectedItem, setSelectedItem] = useState({})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		applySearch,
		applyFilters,
		paginate: paginateFilters,
		resetFilters,
	} = useFilterSearchPagination({
		initialFilterData: {
			'start_date': businessToday(),
			'end_date': businessToday(),
			'pos_id': reduxAccount.pos_id,
			'menu_id': null,
			'cashier_login': null,
			'waiter_login': null,
			'group_by': null,
			'search': '',
		},
		initialPagination: {
			url: '/report-sales',
			response: null
		},
	})

	function buildFilterParams(filterDataCopy = {}, options = {}) {
		const { includePage = true } = options
		var urlParams = ""
		const isValidId = (value) => value !== null && value !== undefined && value !== '' && value !== 'undefined' && !Number.isNaN(Number(value))

		if (isValidId(filterDataCopy.pos_id))
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataCopy.pos_id
		if (isValidId(filterDataCopy.order_type_id))
			urlParams += returnSign(urlParams) + 'order_type_id=' + filterDataCopy.order_type_id
		if (isValidId(filterDataCopy.order_type_delivery))
			urlParams += returnSign(urlParams) + 'order_type_delivery=' + filterDataCopy.order_type_delivery
		if (filterDataCopy.menu_ids && filterDataCopy.menu_ids.length > 0) {
			const ids = filterDataCopy.menu_ids.map(item => item.id).join(',')
			urlParams += returnSign(urlParams) + 'menu_ids=' + ids
		}
		if (filterDataCopy.product_ids && filterDataCopy.product_ids.length > 0) {
			const ids = filterDataCopy.product_ids.map(item => item.id).join(',')
			urlParams += returnSign(urlParams) + 'product_ids=' + ids
		}
		if (filterDataCopy.waiter_ids && filterDataCopy.waiter_ids.length > 0) {
			const ids = filterDataCopy.waiter_ids.map(item => item.id).join(',')
			urlParams += returnSign(urlParams) + 'waiter_ids=' + ids
		}
		if (isValidId(filterDataCopy.preparation_place_id))
			urlParams += returnSign(urlParams) + 'preparation_place_id=' + filterDataCopy.preparation_place_id
		if (isValidId(filterDataCopy.order_type_sub_id))
			urlParams += returnSign(urlParams) + 'order_type_sub_id=' + filterDataCopy.order_type_sub_id
		if (filterDataCopy.payment_type_ids && filterDataCopy.payment_type_ids.length > 0) {
			const ids = filterDataCopy.payment_type_ids.map(item => item.id).join(',')
			urlParams += returnSign(urlParams) + 'payment_type_ids=' + ids
		}
		if (filterDataCopy.group_by)
			urlParams += returnSign(urlParams) + 'group_by=' + filterDataCopy.group_by
		if (filterDataCopy.cashier_login)
			urlParams += returnSign(urlParams) + 'cashier_login=' + filterDataCopy.cashier_login
		if (filterDataCopy.waiter_login)
			urlParams += returnSign(urlParams) + 'waiter_login=' + filterDataCopy.waiter_login
		if (isValidId(filterDataCopy.shift_id))
			urlParams += returnSign(urlParams) + 'shift_id=' + filterDataCopy.shift_id
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (includePage && filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		return urlParams
	}

	async function searchWithFilter(passedData = {}) {
		var filterUrl = "/report-sales"
		var filterDataCopy = { ...filterData, ...(passedData.filterData || {}) }

		const urlParams = buildFilterParams(filterDataCopy, { includePage: true })

		filterDataCopy.urlParams = urlParams

		if (`/report-sales${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl += urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setFilterData(filterDataCopy)
		setDropdownIsOpen(false)
	}

	async function toggleRightbar(boolean = false, item, index) {
		const chequeId = Number(item?.cheque_id)
		if (!chequeId) return

		var dataCopy = [...data.data]

		for (let i = 0; i < dataCopy.length; i++) {
			dataCopy[i]['showSidebar'] = false
		}

		if (boolean) {
			const response = await GET(`/cheques/${chequeId}`, {}, { loader: true })
			if (httpOk(response)) {
				dataCopy[index] = response.data.data
				dataCopy[index]['showSidebar'] = boolean

				setSelectedItem(dataCopy[index])
				setShowRightBar(boolean)
			}
		} else {
			setShowRightBar(boolean)
			setSelectedItem({})
		}
	}

	async function downloadExcelFile() {
		let urlParams = buildFilterParams({ ...filterData }, { includePage: false })
		urlParams += returnSign(urlParams) + 'excel=true'
		const response = await FILE_D(`/report-sales${urlParams}`, { loader: true })
		if (httpOk(response)) {
			const file = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
			const fileUrl = URL.createObjectURL(file)
			const link = document.createElement('a')
			link.href = fileUrl
			link.setAttribute('download', `sales.xlsx`)
			document.body.appendChild(link)
			link.click()
			URL.revokeObjectURL(fileUrl)
		}
	}

	function resetFilter() {
		resetFilters({
			start_date: businessMonthStart(),
			end_date: businessToday(),
			pos_id: null,
			menu_id: null,
			cashier_login: null,
			waiter_login: null,
			group_by: null,
			search: '',
		}, (nextFilterData) => searchWithFilter({ filterData: nextFilterData }))
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	async function paginate(page) {
		paginateFilters(page)
		searchWithFilter({ filterData: { ...filterData, page } })
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getMenu() {
		const response = await GET('/helper/menu')
		if (httpOk(response)) setMenu(response.data)
	}

	async function getUsers() {
		const response = await GET('/helper/users')
		if (httpOk(response)) setUsers(response.data)
	}

	async function getPaymentTypes() {
		const response = await GET('/helper/payment-types')
		if (httpOk(response)) setPaymentTypes(response.data)
	}

	async function getPreparationPlaces(pos_id = null) {
		var filterPosId = pos_id ?? filterData.pos_id
		if (filterPosId === null || filterPosId === undefined || filterPosId === '' || filterPosId === 'undefined' || Number.isNaN(Number(filterPosId))) {
			setPreparationPlaces([])
			return
		}
		var response = await GET(`/helper/preparation-places?pos_id=${filterPosId}`)
		if (httpOk(response)) setPreparationPlaces(response.data)
	}

	async function getOrderTypes() {
		const response = await GET('/helper/order-types')
		if (httpOk(response)) setOrderTypes(response.data)
	}

	async function getOrderSubTypes() {
		const response = await GET('/helper/order-type-subs')
		if (httpOk(response)) setOrderSubTypes(response.data)
	}

	async function getProducts() {
		const response = await GET(`/helper/products`)
		if (httpOk(response)) setProducts(response.data)
	}

	useEffect(() => {
		getMenu()
		getPoses()
		getUsers()
		getProducts()
		getPaymentTypes()
		getOrderTypes()
		getOrderSubTypes()
		getPreparationPlaces()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header">
				<h4 className="vertical-center h-100">
					{t('sales')} [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, (nextFilterData) => {
										searchWithFilter({ filterData: nextFilterData })
									})}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => {
														const nextPosId = option ? option.id : null
														setFilterData({ ...filterData, 'pos_id': nextPosId })
														getPreparationPlaces(nextPosId)
													}}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('payment_types')}</label>
												<Select
													isMulti
													isClearable
													options={paymentTypes}
													value={filterData.payment_type_ids}
													onChange={(options) => setFilterData({ ...filterData, 'payment_type_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('order_type')}</label>
												<Select
													isClearable
													options={orderTypes}
													value={orderTypes.find(option => option.id === filterData.order_type_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'order_type_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('delivery_type')}</label>
												<Select
													isClearable
													options={orderSubTypes}
													value={orderSubTypes.find(option => option.id === filterData.order_type_sub_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'order_type_sub_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('menu')}</label>
												<Select
													isMulti
													isClearable
													options={menu}
													value={filterData.menu_ids}
													onChange={(options) => setFilterData({ ...filterData, 'menu_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('products')}</label>
												<Select
													isMulti
													isClearable
													options={products}
													value={filterData.product_ids}
													onChange={(options) => setFilterData({ ...filterData, 'product_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('employee')}</label>
												<Select
													isMulti
													isClearable
													options={users}
													value={filterData.waiter_ids}
													onChange={(options) => setFilterData({ ...filterData, 'waiter_ids': options ? options : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('group')}</label>
												<Select
													isClearable
													options={groupBy}
													value={groupBy.find(option => option.id === filterData.group_by) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'group_by': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('shift')} ID</label>
												<input type="text" className="form-control"
													onChange={(e) => setFilterData({ ...filterData, 'shift_id': e.target.value })} />
											</div>
											<div className="form-group col-md-6">
												<label>{t('preparation_places')}</label>
												<Select
													isClearable
													options={preparationPlaces}
													value={preparationPlaces.find(option => option.id === filterData.preparation_place_id) || ''}
													onChange={(option) => setFilterData({ ...filterData, 'preparation_place_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => setFilterData({ ...filterData, ...period })}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end gap-2">
													<button className="btn btn-secondary"
														onClick={() => setDropdownIsOpen(false)}>
														{t('cancel')}
													</button>
													<button className="btn btn-primary"
														onClick={() => applyFilters((nextFilterData) => {
															searchWithFilter({ filterData: { ...nextFilterData, page: null } })
														})}>
														{t('apply')}
													</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
							<div>
								<button className="btn btn-outline-primary btn-wide-2"
									onClick={() => downloadExcelFile()}>
									<i className="uil uil-file-download-alt"></i>
								</button>
							</div>
						</div>
						<div className="vertical-center">
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('sales')}:</b> {formatMoney(data.total_sales)}
							</h6>
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('allowances')}:</b> {formatMoney(data.total_allowance)}
							</h6>
							<h6 className="d-flex justify-content-between gap-3">
								<b>{t('amount')}:</b> {formatMoney(data.total_amount)}
							</h6>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterData.pos_id, 'name')}
									</span>
								}
								{filterData.menu_id &&
									<span className="me-2">
										<b>{t('menu')}: </b>
										{findKeyFromArrayByValue(menu, 'id', filterData.menu_id, 'name')}
									</span>
								}
								{filterData.preparation_place_id &&
									<span className="me-2">
										<b>{t('preparation_places')}: </b>
										{findKeyFromArrayByValue(preparationPlaces, 'id', filterData.preparation_place_id, 'name')}
									</span>
								}
								{filterData.waiter_login &&
									<span className="me-2">
										<b>{t('waiter')}: </b>
										{findKeyFromArrayByValue(users, 'login', filterData.cashier_login, 'first_name')}
									</span>
								}
								{filterData.order_type_id &&
									<span className="me-2">
										<b>{t('order_type')}: </b>
										{findKeyFromArrayByValue(orderTypes, 'id', filterData.order_type_id, 'name')}
									</span>
								}
								{filterData.order_type_sub_id &&
									<span className="me-2">
										<b>{t('delivery_type')}: </b>
										{findKeyFromArrayByValue(orderSubTypes, 'id', filterData.order_type_sub_id, 'name')}
									</span>
								}
								{filterData.group_by &&
									<span className="me-2">
										<b>{t('group')}: </b>
										{findKeyFromArrayByValue(groupBy, 'id', filterData.group_by, 'name')}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									{t('reset')}
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '15%' }}>{t('menu')}</th>
									<th style={{ 'width': '20%' }}>{t('product')}</th>
									<th style={{ 'width': '10%' }}>{t('debtor')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('open_date')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('close_date')}</th>
									<th style={{ 'width': '5%' }} className="text-end">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('sale_price')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.data.map((item, index) => {
									const canOpenCheque = !!Number(item?.cheque_id)
									return (
										<tr key={index}
											className={(canOpenCheque ? 'cursor' : '') + (item.showSidebar ? ' table-tr-active' : '')}
											onClick={canOpenCheque ? () => toggleRightbar(true, item, index) : undefined}>
											<td className="text-center">{item.row_number}</td>
											<td className="td-ellipsis">{item.pos_name}</td>
											<td className="td-ellipsis">{item.menu_name}</td>
											<td className="td-ellipsis">{item.product_name}</td>
											<td className="td-ellipsis">{item.entity_name}</td>
											<td className="text-center">{formatDate(item.cheque_opened_at, 'dd.MM.yy HH:mm')}</td>
											<td className="text-center">{formatDate(item.cheque_closed_at, 'dd.MM.yy HH:mm')}</td>
											<td className="text-end">{formatMoney(item.quantity, 2)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.sale_price)}</td>
											<td className="text-end text-nowrap">{formatMoney(item.total_price)}</td>
										</tr>
									)
								})}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-nowrap text-end"><b>{formatMoney(data.total_quantity, 2)}</b></td>
									<td></td>
									<td className="text-nowrap text-end"><b>{formatMoney(data.total_sales)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			<Rightbar
				showRightBar={showRightBar}
				setShowRightBar={setShowRightBar}
				selectedItem={selectedItem}>
			</Rightbar>
		</>
	)
}

export default Index